import * as FuelCardsActions from '../actions/fuel-card.actions';
import { FileMetaData } from '../../../fuel-card/models/file-meta-data';
import { PaginationWrapper } from '../../../shared/models/pagination-wrapper';
import { FuelCard } from '../../../fuel-card/models/fuel-card';
import { FuelingMerge } from '../../../fuel-card/models/fueling-merge';
import * as AuthApiActions from '../../auth/actions/auth-api.actions';
import { AuthApiActionsUnion } from '../../auth/actions/auth-api.actions';

export interface State {
  fuelCards: PaginationWrapper<FuelCard>;
  filesMetaData: FileMetaData[];
  fuelingMergedData: FuelingMerge[];
}

export const initialState: State = {
  fuelCards: null,
  filesMetaData: null,
  fuelingMergedData: null
}
export function reducer(
  state = initialState,
  action: FuelCardsActions.FuelCardsActionsUnion | AuthApiActionsUnion
): State {
  switch (action.type) {
    case FuelCardsActions.getFuelCardsSuccess.type: {
      return {
        ...state,
        fuelCards: action.data
      };
    }
    case FuelCardsActions.getFilesMetaDataSuccess.type: {
      return {
        ...state,
        filesMetaData: action.data
      };
    }
    case FuelCardsActions.getFuelingMergeDataSuccess.type: {
      return {
        ...state,
        fuelingMergedData: action.data
      };
    }
    case FuelCardsActions.updateFuelingMergeSuccess.type:
    case FuelCardsActions.mergeFuelingMergeSuccess.type: {
      const fuelingMergedData: FuelingMerge[] = [...state.fuelingMergedData];
      if (action?.data?.deletedFuelingMergeId1) {
        fuelingMergedData.splice(fuelingMergedData.findIndex(x => x.fuelingMergeId === action.data.deletedFuelingMergeId1), 1);
      }
      if (action?.data?.deletedFuelingMergeId2) {
        fuelingMergedData.splice(fuelingMergedData.findIndex(x => x.fuelingMergeId === action.data.deletedFuelingMergeId2), 1);
      }
      return {
        ...state,
        fuelingMergedData: fuelingMergedData
      };
    }
    case FuelCardsActions.getFuelingMergeByIdsSuccess.type: {
      const fuelingMergedData: FuelingMerge[] = [...state.fuelingMergedData];
      if (action.data) {
        action.data.forEach((item: FuelingMerge) => {
          const fuelingMerge = fuelingMergedData.find(x => x.fuelingMergeId === item.fuelingMergeId);
          if (fuelingMerge) {
            FuelingMerge.copy(item, fuelingMerge);
          } else {
            fuelingMergedData.splice(fuelingMergedData.findIndex(x => x.fuelingMergeId === item.fuelingMergeId), 0, item);
          }
        });
      }

      return {
        ...state,
        fuelingMergedData: fuelingMergedData.sort((a: FuelingMerge, b: FuelingMerge): number => new Date(b.eventAt).getTime() - new Date(a.eventAt).getTime())
      };
    }
    case FuelCardsActions.unMergeFuelingMergeSuccess.type:
    case FuelCardsActions.deleteFuelingMergeByIdSuccess.type: {
      const fuelingMergedData: FuelingMerge[] = [...state.fuelingMergedData];
      if (action.fuelingMergeId) {
        fuelingMergedData.splice(fuelingMergedData.findIndex(x => x.fuelingMergeId === action.fuelingMergeId), 1);
      }
      return {
        ...state,
        fuelingMergedData: fuelingMergedData
      };
    }
    case FuelCardsActions.markAsRealFuelingByIdsSuccess.type: {
      const fuelingMergedData = state.fuelingMergedData.map(fuelingMerge =>
        action.data.includes(fuelingMerge.fuelingMergeId)
          ? { ...fuelingMerge, isCorrect: true, markedAsNotReal: false }
          : fuelingMerge
      );
      return {
        ...state,
        fuelingMergedData
      };
    }
    
    case FuelCardsActions.markAsNotRealFuelingByIdsSuccess.type: {
      const fuelingMergedData = state.fuelingMergedData.map(fuelingMerge =>
        action.data.includes(fuelingMerge.fuelingMergeId)
          ? { ...fuelingMerge, isCorrect: false, markedAsNotReal: true }
          : fuelingMerge
      );
      return {
        ...state,
        fuelingMergedData
      };
    }
    case AuthApiActions.logoutSuccess.type:
    case AuthApiActions.logoutFailure.type: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export const getFuelCards = (state: State) => state.fuelCards;
export const getFilesMetaData = (state: State) => state.filesMetaData;
export const getFuelingMergeData = (state: State) => state.fuelingMergedData;
